import React from "react";
import { TableCell, TableSortLabel } from "@mui/material";
import TableHeader from "@crema/core/AppTable/TableHeader";
import { LeadMasterData } from "types/models/leadMaster/LeadMasterApp";

interface TableHeadingProps {
  order: "asc" | "desc";
  orderBy: keyof LeadMasterData;
  onSort: (property: keyof LeadMasterData) => void;
}

const commonCellStyle = {
  fontSize: 14,
  width: 200,
  maxWidth: 180,
  minWidth: 160,
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
};

// Columns you want to show (subset of LeadMasterData)
const headCells: { id: keyof LeadMasterData; label: string }[] = [
  { id: "updatedOn", label: "Date" },
  { id: "leadSource", label: "Source" },
  { id: "mediumSource", label: "Reference" },
  { id: "customerName", label: "Name" },
  { id: "contactNumber", label: "Mobile" },
  { id: "emailId", label: "Email" },
  { id: "city", label: "City" },
  { id: "area", label: "Area" },
  { id: "address", label: "Address" },
  { id: "polygonDistance", label: "RFS" }, // RFS depends on distance
  { id: "polygonDistance", label: "Distance" },
  { id: "latLong", label: "Latlong" },
  { id: "remarks", label: "Remarks" },
];

const TableHeading: React.FC<TableHeadingProps> = ({ order, orderBy, onSort }) => {
  return (
    <TableHeader>
      {headCells.map((headCell) => (
        <TableCell
          key={headCell.id + headCell.label}
          sx={commonCellStyle}
          sortDirection={orderBy === headCell.id ? order : false}
        >
          <TableSortLabel
            active={orderBy === headCell.id}
            direction={orderBy === headCell.id ? order : "asc"}
            onClick={() => onSort(headCell.id)}
          >
            {headCell.label}
          </TableSortLabel>
        </TableCell>
      ))}
    </TableHeader>
  );
};

export default TableHeading;
